import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { Paginate } from 'src/app/models/paginate';
import { ApplicationStorageService } from 'src/app/application/services/application-storage.service';
import { faPlayCircle, faThList } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-application-list',
  templateUrl: './application-list.component.html',
  styleUrls: ['./application-list.component.scss']
})
export class ApplicationListComponent implements OnInit {

	public applicationPagination: Paginate;
	public applicationsLoading: boolean;
	public queryParams = <any>{};
	public subscriptions = {
    	mediaList:null,
    	pageParams:null
  };
  numApplications: number;

  playCircle = faPlayCircle;
  thCircle = faThList;

  displayMode="grid";

  // CR 2026-06-12: when an approved buyer clicks their unit, take them straight
  // to the Fibre tab — unless they have opted out (checkbox on the Fibre tab)
  // or already submitted a fibre application. Same localStorage keys the Fibre
  // component writes.
  private readonly fibreSubmittedPrefix = 'fibre_submitted_';
  private readonly fibreOptOutPrefix = 'fibre_optout_';


	public searchForm = new FormGroup({
		search: new FormControl('', Validators.required),
	})

	get search(): any {
  	return this.searchForm.get('search');
	}

  constructor(
    private _activated_route: ActivatedRoute,
    private _router: Router,
    private _application_service: ApplicationStorageService
  ) { 
  	this.subscriptions.pageParams = this._activated_route.queryParams.subscribe((params)=>{
			this.queryParams = Object.assign(this.queryParams, params);
      	this.loadApplications(this.queryParams)
    }); 
  }

  ngOnInit(): void {}

  resetForm(){
		this._router.navigate([],{
      relativeTo: this._activated_route,
      queryParams: Object.assign(this.queryParams, {search: '',page: 1}), 
      queryParamsHandling: 'merge',
    });
	}

	onSearchSubmit(){
		this._router.navigate([],{
        relativeTo: this._activated_route,
        queryParams: Object.assign(this.queryParams, {search: this.search.value,page: 1}), 
        queryParamsHandling: 'merge',
    });
	}
  
	loadApplications(params) {
    this.applicationsLoading = true;

    this.subscriptions.mediaList = this._application_service.list$(params)
    .pipe( finalize(()=> this.applicationsLoading = false ))
    .subscribe((res)=> {
      this.applicationPagination = res;
      this.numApplications = this.applicationPagination.data.length;
    })
	}

	onPageChange($event) {
		this._router.navigate([],{
      relativeTo: this._activated_route,
      queryParams:  Object.assign(this.queryParams, {page:$event}), 
      queryParamsHandling: 'merge',
    });
  }
  
  openApplication(application) {
    if(application.status.code == 'susp') {
      return;
    }

    if(this.shouldRedirectToFibre(application)) {
      this._router.navigate(application.action_url, { fragment: 'fibre' });
      return;
    }

    this._router.navigate(application.action_url);
  }

  /**
   * Approved buyers go straight to the Fibre tab on a unit click, unless they
   * opted out or already submitted a fibre application.
   */
  private shouldRedirectToFibre(application): boolean {
    const code = application && application.status && application.status.code;
    if(code != 'apprvd_sold' && code != 'cash_apprvd_sold') {
      return false;
    }

    const token = application && application.token;
    if(!token) {
      return false;
    }

    return !localStorage.getItem(this.fibreOptOutPrefix + token)
        && !localStorage.getItem(this.fibreSubmittedPrefix + token);
  }

	ngOnDestroy(): void {
    Object.keys(this.subscriptions).forEach(s=>{
      this.subscriptions[s].unsubscribe();
    })
  }
}
